var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5330_22066)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FEE500"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5330_22066",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 10,
    width: 17,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.298 10.0742H8.89062V22.5928H24.298V10.0742Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5330_22066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.246 22.4994C11.914 21.7481 12.5442 20.9745 12.7867 19.9481C12.4857 19.7406 12.1683 19.5394 11.8686 19.3131C9.976 17.8821 9.34027 15.6254 10.2825 13.5838C10.8371 12.3819 11.7649 11.5123 12.9373 10.9677C15.8305 9.62386 18.6475 9.75613 21.2893 11.6355C23.0128 12.8617 23.7385 15.0057 23.1091 16.8391C22.5991 18.325 21.5531 19.3235 20.1959 20.015C18.765 20.744 17.2421 20.9473 15.6594 20.8137C15.4752 20.7983 15.2553 20.8561 15.0973 20.9543C14.0403 21.6137 12.9139 22.113 11.7373 22.5029C11.6013 22.5482 11.4556 22.5635 11.3147 22.5927C11.292 22.5614 11.2687 22.5307 11.246 22.4994Z",
    fill: "#181600"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5330_22066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.dc782c3af4e147a8c79fa1d02cedbf6b.svg";
export { ForwardRef as ReactComponent };